/**
 * @flow
 * @relayHash 4af2f0d625eba9fd9e02f9b8c3119a78
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProductIssuesTable_project$ref = any;
export type ecommerce_ProductIssuesTable_QueryVariables = {|
  host: string
|};
export type ecommerce_ProductIssuesTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: ProductIssuesTable_project$ref
  |}
|};
export type ecommerce_ProductIssuesTable_Query = {|
  variables: ecommerce_ProductIssuesTable_QueryVariables,
  response: ecommerce_ProductIssuesTable_QueryResponse,
|};
*/


/*
query ecommerce_ProductIssuesTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...ProductIssuesTable_project
    id
  }
}

fragment ProductIssuesTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        productIssues(offset: 0, limit: 20, levels: [], sourceUrl: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...ProductIssuesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ProductIssuesRow_issue on ProductIssue {
  id
  source_url
  issue
  level
  name
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ecommerce_ProductIssuesTable_Query",
  "id": null,
  "text": "query ecommerce_ProductIssuesTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...ProductIssuesTable_project\n    id\n  }\n}\n\nfragment ProductIssuesTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        productIssues(offset: 0, limit: 20, levels: [], sourceUrl: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...ProductIssuesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ProductIssuesRow_issue on ProductIssue {\n  id\n  source_url\n  issue\n  level\n  name\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ecommerce_ProductIssuesTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProductIssuesTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ecommerce_ProductIssuesTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "productIssues",
                        "storageKey": "productIssues(levels:[],limit:20,offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "levels",
                            "value": [],
                            "type": "[String!]"
                          },
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          {
                            "kind": "Literal",
                            "name": "sourceUrl",
                            "value": {
                              "operator": "AND",
                              "values": []
                            },
                            "type": "TextFilters"
                          }
                        ],
                        "concreteType": "ProductIssueConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProductIssueEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProductIssue",
                                "plural": false,
                                "selections": [
                                  v3,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "issue",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "level",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          v3
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9e81a72186612667d7c56790fbb3e5f7';
module.exports = node;
